// extracted by mini-css-extract-plugin
export default {"loader":"index_loader__Q1LVL","gif":"index_gif__ZDnCo","microphone":"index_microphone__qMEA1","loader2":"index_loader2__t9HEB"};